var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{ref:"axisX",attrs:{"data-role":"AxisX","transform":("translate(0, " + (_vm.CHART_SIZE.height - _vm.CHART_SIZE.marginBottom) + ")")}})}
var staticRenderFns = []

export { render, staticRenderFns }